<template>
  <div class="big">
    <DocMsg :isFlag="doc_msg"
            :doctorId="doctorId"></DocMsg>
    <div class="page_title flex_between">
      <span>病历详情</span>
      <el-button type="primary"
                 style="width:92px;"
                 size="medium"
                 @click="back">返回</el-button>
    </div>

    <div style="padding:20px;">
      <div class="container">
        <div class="inbobox">
          <div class="inboitem">
            <div>
              <span class="infotitle"
                    style="display:inline-block">医生姓名：</span>
              <span @click="showDocMsg(detail.doctor_id)"
                    style="cursor:pointer">{{detail.doctor_name}}</span>
            </div>
            <div style="margin:0 40px">
              <span>性别：</span>
              <span v-if="detail.doctor_sex==1">男</span>
              <span v-if="detail.doctor_sex==2">女</span>
            </div>
            <div>
              <span>手机号：</span>
              <span>{{detail.doctor_phone}}</span>
            </div>
          </div>
          <div class="inboitem">
            <div class="infotitle">职称：</div>
            <div>{{detail.title}}</div>
          </div>
          <div class="inboitem">
            <div class="infotitle">科室：</div>
            <div>{{detail.department_name}}</div>
          </div>
        </div>

        <div style="margin:20px 0;"
             class="littletitle">诊断</div>
        <div>
          <span>患者：</span>
          <span>{{detail.user_name}}</span>
          <span style="margin:0 30px"
                v-if="detail.patient_sex==1">男</span>
          <span style="margin:0 30px"
                v-if="detail.patient_sex==2">女</span>
          <span style="margin:0 30px"
                v-if="detail.patient_sex==0">未知</span>
          <span>{{detail.age}}</span>
        </div>
        <div style="margin:16px 0">
          <span>主诉：</span>
          <span>{{detail.chief_complaint}}</span>
        </div>
        <div>
          <span>诊断：</span>
          <span>{{detail.diagnosis}}</span>
        </div>
        <div style="margin:20px 0;"
             class="littletitle">开方</div>
        <div style="font-size: 22px;color: #000000;font-weight:600;margin-bottom:20px">Rp：</div>
        <div class="itembox">
          <div class="item"
               v-for="(item,index) in detail.item_list"
               :key="index">
            <span>{{item.generic_name}}</span>
            <span>
              <span>{{item.item_use_level}}g</span>
              <span v-if="item.requirement">({{item.requirement}})</span>
            </span>
          </div>
        </div>
        <div style="color:#747981">
          <span>共</span>
          <span style="color:#70a06c;font-weight:600;margin:0 5px">{{detail.total_num}}</span>
          <span>剂，每日 1 剂，每剂分</span>

          <span style="color:#70a06c;font-weight:600;margin:0 5px">{{detail.day_num}}</span>
          <span>次服用</span>
        </div>
        <div style="margin:30px 0 20px;"
             class="littletitle">医嘱</div>
        <div>
          <span>用法：</span>
          <span>{{detail.use_method}}</span>
        </div>
        <div style="margin:16px 0">
          <span>禁忌：</span>
          <span>{{detail.taboo}}</span>
        </div>
        <div>
          <span>特殊说明：</span>
          <span>{{detail.doctor_advice}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import yewu from '../../../api/yewu';
import DocMsg from '../../../components/common/DocMsg.vue';
export default {
  data() {
    return {
      wenzhendan: false,
      detail: {},
      doc_msg: false,
      doctorId: ''
    };
  },
  components: {
    DocMsg
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //病历详情
    getDetail() {
      let pre_id = this.$route.query.pre_id;
      yewu.casehistoryItem({ pre_id }).then((res) => {
        if (res.code == 0) {
          this.detail = res.data.info;
        }
      });
    },

    back() {
      history.back();
    }
  },
  created() {
    this.getDetail();
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  border-radius: 5px;
  text-align: left;
}

.inbobox {
  width: 600px;
  padding: 14px 0 2px 20px;
  box-sizing: border-box;
  background-color: #f9f8ee;
  border: solid 1px #dad8ca;
  .inboitem {
    display: flex;
    margin-bottom: 12px;
    .infotitle {
      width: 80px;
    }
  }
}

.gray {
  color: #747981;
}
.green {
  color: #669961;
  cursor: pointer;
}
.log {
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  border: solid 1px #e1e3e9;
  margin-bottom: 14px;
  .loginfo {
    // width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 18px;
    .infotxt {
      width: 88%;
      word-wrap: break-word;
    }
  }
}
.littletitle {
  font-size: 16px;
  font-weight: 600;
}
.myimg {
  width: 120px;
  height: 120px;
  margin-right: 10px;
  margin-bottom: 10px;
  cursor: pointer;
}
.wenzhentitle {
  line-height: 24px;
  font-weight: 600;
}
.wenzhencontent {
  color: #669961;
  line-height: 20px;
  padding-left: 10px;
}
.itembox {
  display: flex;
  color: #000;
  flex-wrap: wrap;
  .item {
    width: 180px;
    display: flex;
    justify-content: space-between;
    margin-right: 40px;
    position: relative;
    margin-bottom: 22px;
  }
  .item::before {
    content: '';
    position: absolute;
    height: 12px;
    width: 1px;
    background: #d7d7d7;
    left: 200px;
    top: 4px;
  }
}
</style>